import httpClient from '@/http-client'

export const get = data => {
  return httpClient
    .post('/api/v1/location-tracking', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const nearest = data => {
  return httpClient
    .post('/api/v1/location-tracking/nearest', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const employee = (Options = {}) => {
  return httpClient
    .get('/api/v1/location-tracking/employees', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const userGroup = (Options = {}) => {
  return httpClient
    .get('/api/v1/location-tracking/user-group', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const district = (Options = {}) => {
  return httpClient
    .get('/api/v1/location-tracking/districts', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const historyVisited = data => {
  return httpClient
    .post('/api/v1/location-tracking/history-visits', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const historyVisitedExcel = data => {
  return httpClient
    .post('/api/v1/location-tracking/history-visits/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  employee,
  district,
  nearest,
  userGroup,
  historyVisited,
  historyVisitedExcel
}
